import { useEffect } from 'react';

const BADGE_HIDE_DELAY_MS = 3000;

const scheduleBadgeHide = (badge: Element) => {
  if (badge.getAttribute('data-hide-scheduled') === 'true') {
    return;
  }

  badge.setAttribute('data-hide-scheduled', 'true');
  window.setTimeout(() => {
    badge.classList.add('recaptcha-badge--hidden');
  }, BADGE_HIDE_DELAY_MS);
};

const hideExistingBadges = () => {
  document.querySelectorAll('.grecaptcha-badge').forEach(scheduleBadgeHide);
};

export const useHideRecaptchaBadge = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    hideExistingBadges();

    const observer = new MutationObserver(hideExistingBadges);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      document.querySelectorAll('.grecaptcha-badge').forEach((badge) => {
        badge.classList.remove('recaptcha-badge--hidden');
        badge.removeAttribute('data-hide-scheduled');
      });
    };
  }, [enabled]);
};
